import { useSelector } from 'react-redux';
import { colors } from '../../../../colors';
import { OverviewChartType } from '../../types';
import {
  selectOverviewChartType,
  setOverviewChartType,
} from '../../../../store/slices/ui';
import './index.css';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useWidthBreakpoint from '../../../../hooks/useWidthBreakpoint';

const OverviewChartTypeSelector = () => {
  const overviewChartType = useSelector(selectOverviewChartType);
  const dispatch = useDispatch();
  const { isMatch } = useWidthBreakpoint();

  const handleClick = useCallback(() => {
    if (overviewChartType === OverviewChartType.FullBalance) {
      dispatch(setOverviewChartType(OverviewChartType.ProfitOnly));
      return;
    }

    dispatch(setOverviewChartType(OverviewChartType.FullBalance));
  }, [dispatch, overviewChartType]);

  const label = useMemo(() => {
    if (overviewChartType === OverviewChartType.FullBalance) {
      return 'Full Balance';
    }

    return 'Profit Only';
  }, [overviewChartType]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: isMatch('md') ? 'auto' : '100vw',
        marginTop: -10,
      }}
    >
      <div
        className="overview-chart-timeframe"
        style={{
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 2,
          paddingBottom: 2,
          backgroundColor: colors.white,
          color: colors.black,
          cursor: 'pointer',
          fontWeight: 'bold',
          marginLeft: 8,
          marginRight: 8,
          borderRadius: 12,
          fontSize: 14,
        }}
        onClick={handleClick}
      >
        {label}
      </div>
    </div>
  );
};

export default OverviewChartTypeSelector;
